import React, { useState } from 'react';
import styles from './styles.module.css';

function License({ record }) {
  const [showAllLicenses, setShowAllLicenses] = useState(false);

  const toggleLicenses = () => setShowAllLicenses(!showAllLicenses);

  const licensesToShow = (record?.licenses || [])
    .filter(license => license.type && license.value);
  const displayedLicenses = showAllLicenses ? licensesToShow : licensesToShow.slice(0, 4);

  return (
    <div className={styles.licensePeopleContainer}>
      <section className={styles.licensePeopleSectionContainer}>
        <h1 className={styles.licensePeopleHeader}>Licenses</h1>
        <div className={styles.licensesFlexContainer}>
          <div className={styles.licensesLeftContainer}>
            {displayedLicenses.length > 0 ? (
              displayedLicenses.map((license, index) => (
                <div key={index} className={styles.licensePeopleItem}>
                  <span className={styles.licensePeopleText} style={{ display: "flex" }}>
                    <span>{license.type}</span>
                    <span className={styles.licensePeopleValue}>
                      {license.value}
                    </span>
                  </span>
                </div>
              ))
            ) : (
              <div className={styles.licensePeopleItem}>
                <span className={styles.licensePeopleText}>N/A</span>
              </div>
            )}
            {licensesToShow.length > 4 && (
              <span className={styles.licensePeopleExpand} onClick={toggleLicenses}>
                {showAllLicenses ? 'Show Less' : `Expand All (${licensesToShow.length})`}
              </span>
            )}
          </div>
          <div className={styles.licensesRightContainer}>
            {/*  */}
          </div>
        </div>
      </section>
    </div>
  );
}


export default License;
